package amazon.lastmile.inject

import com.karawek.core.auth.`internal`.DefaultAuthSessionStore
import com.karawek.core.auth.api.AuthSessionStore
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultAuthSessionStore::class)
public interface ComKarawekCoreAuthInternalDefaultAuthSessionStore {
  @Provides
  public fun provideDefaultAuthSessionStoreAuthSessionStore(defaultAuthSessionStore: DefaultAuthSessionStore): AuthSessionStore = defaultAuthSessionStore
}
